module.exports = __webpack_public_path__ + "img/logo (7).2811c09c.png";